import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

// tools
import AuthenticationService from '../../service/authentication-service';
import ErrorBoundary from '../ErrorBoundary';

const ProtectedRoute = () => {

    // Conserviamo la pagina richiesta: dopo il login si torna li' (deep-link dalle mail).
    const from = encodeURIComponent(window.location.pathname + window.location.search);

    if (!AuthenticationService.wasLoggedIn()) {
        return (<Navigate to={'/login?from=' + from} replace/>);
    }

    if (AuthenticationService.isExpired()) {
        return (<Navigate to={'/login?redirectReason=expired&from=' + from} replace/>);
    }

    if (!AuthenticationService.isLoggedIn()) {
        return (<Navigate to={'/login?redirectReason=auth_required&from=' + from} replace/>);
    }

    /*if (window.location.pathname === '/') {
        return (<Navigate to={'/'} replace/>);
    }*/

    return <ErrorBoundary><Outlet/></ErrorBoundary>;
}

export default ProtectedRoute;